module.exports = __webpack_public_path__ + "img/correct_btn.a4af4663.png";